module.exports = __webpack_public_path__ + "images/btn-arrow-right.ace8cb6cbb.svg";